export default "__VITE_ASSET__gVw_1r6Y__";